Prism.languages.brightscript = {
  comment: /(?:\brem|').*/i,
  "directive-statement": {
    pattern: /(^[\t ]*)#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if).*/im,
    lookbehind: !0,
    alias: "property",
    inside: {
      "error-message": {
        pattern: /(^#error).+/,
        lookbehind: !0
      },
      directive: {
        pattern: /^#(?:const|else(?:[\t ]+if)?|end[\t ]+if|error|if)/,
        alias: "keyword"
      },
      expression: {
        pattern: /[\s\S]+/,
        inside: null
      }
    }
  },
  property: {
    pattern: /([\r\n{,][\t ]*)(?:(?!\d)\w+|"(?:[^"\r\n]|"")*"(?!"))(?=[ \t]*:)/,
    lookbehind: !0,
    greedy: !0
  },
  string: {
    pattern: /"(?:[^"\r\n]|"")*"(?!")/,
    greedy: !0
  },
  "class-name": {
    pattern: /(\bAs[\t ]+)\w+/i,
    lookbehind: !0
  },
  keyword: /\b(?:As|Dim|Each|Else|Elseif|End|Exit|For|Function|Goto|If|In|Print|Return|Step|Stop|Sub|Then|To|While)\b/i,
  boolean: /\b(?:false|true)\b/i,
  function: /\b(?!\d)\w+(?=[\t ]*\()/,
  number: /(?:\b\d+(?:\.\d+)?(?:[ed][+-]\d+)?|&h[a-f\d]+)\b[%&!#]?/i,
  operator: /--|\+\+|>>=?|<<=?|<>|[-+*/\\<>]=?|[:^=?]|\b(?:and|mod|not|or)\b/i,
  punctuation: /[.,;()[\]{}]/,
  constant: /\b(?:LINE_NUM)\b/i
}, Prism.languages.brightscript["directive-statement"].inside.expression.inside = Prism.languages.brightscript;